import axios from 'axios';
import React, { useEffect, useState } from 'react';

import { fileIconList } from '../assets/data';

const services = {
  figma: {
    pattern: /^(?:https:\/\/)?(?:www\.)?figma\.com/,
    icon: 'https://static.figma.com/app/icon/1/favicon.svg',
  },
  youtube: {
    pattern: /^(?:https:\/\/)?(?:www\.)?youtube\.com/,
    icon: 'https://www.youtube.com/favicon.ico',
  },
  gsheets: {
    pattern: /^(?:https:\/\/)?(?:www\.)?docs\.google\.com\/spreadsheets/,
    icon: 'https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico',
  },
};

export const EmbedFavicon = ({ url }: { url: string | undefined }) => {
  const [iconPath, setIconpath] = useState<string>('');
  const [hasImageLoadError, setHasImageLoadError] = useState<boolean>(false);

  useEffect(() => {
    setHasImageLoadError(false);
    if (url) {
      if (services.figma.pattern.test(url)) {
        setIconpath(services.figma.icon);
      } else if (services.youtube.pattern.test(url)) {
        setIconpath(services.youtube.icon);
      } else {
        axios.get(`/api/favicon?path=${encodeURI(url)}`).then((data) => {
          const [icon] = data.data.icons;
          if (icon?.src) {
            setIconpath(icon.src);
          }
        });
      }
    } else {
      setIconpath('');
    }
  }, [url]);

  const onImageLoadError = () => {
    setHasImageLoadError(true);
  };

  return iconPath && !hasImageLoadError ? (
    <img
      src={iconPath}
      onError={onImageLoadError}
      className="-mt-2"
      alt="Embed Favicon"
      width={16}
      height={16}
    />
  ) : (
    fileIconList.embed
  );
};

export const EmbedFaviconWithTitle = ({
  url,
  name,
  titleClassName = 'max-w-100',
}: {
  url: string | undefined;
  name: string;
  titleClassName?: string;
}) => {
  const [iconPath, setIconpath] = useState<string>('');
  const [pageTitle, setPageTitle] = useState<string>(name && name.length > 0 ? name : 'Embed');
  const [hasImageLoadError, setHasImageLoadError] = useState<boolean>(false);

  useEffect(() => {
    if (name && name.length > 0) setPageTitle(name);
    setHasImageLoadError(false);
    if (url) {
      axios.get(`/api/favicon?path=${encodeURI(url)}`).then((data) => {
        const [icon] = data.data.icons;
        if (services.figma.pattern.test(url)) {
          setIconpath(services.figma.icon);
        } else if (services.youtube.pattern.test(url)) {
          setIconpath(services.youtube.icon);
        } else if (services.gsheets.pattern.test(url)) {
          setIconpath(services.gsheets.icon);
        } else if (icon?.src) {
          setIconpath(icon.src);
        }
        if (data.data.title) {
          setPageTitle(name && name.length > 0 ? name : data.data.title);
        }
      });
    } else {
      setIconpath('');
    }
  }, [url, name]);

  const onImageLoadError = () => {
    setHasImageLoadError(true);
  };

  return (
    <>
      <span className="block mt-2 mr-6">
        {iconPath && !hasImageLoadError ? (
          <img
            src={iconPath}
            onError={onImageLoadError}
            className="-mt-2"
            alt="Embed Favicon"
            width={16}
            height={16}
          />
        ) : (
          fileIconList.embed
        )}
      </span>
      <span
        title={pageTitle}
        className={`capitalize mr-6 text-gray-500 truncate text-left ${titleClassName}`}
      >
        {pageTitle}
      </span>
    </>
  );
};
